module.exports = __webpack_public_path__ + "files/c5da5d69ad8e29e466ba1ea5b7781df4.png";